/* Copyright (c) Trimble Inc. All rights reserved. */

import { useEffect } from "react";
import { ProductListViewModel } from "pages/home/products/components/ProductList.viewer";
import { AsyncActionState, useAsyncAction } from "legacy-components/form/action/AsyncAction";
import { Controller } from "modus/utilities/ViewController";
import { IProduct } from "pages/home/consumer/service/ProductService";
import { AxiosResponse } from "axios";
import { GlobalProductService } from "pages/home/consumer/service/GlobalProductService";

/**
 * @name useTeamListController
 * @description controller to handle TeamList component functionalities and serves model for ApplicationViewer
 * @type Controller
 * @input TeamListControllerProps
 * @output TeamListViewModel
 */
export const useGlobalProductListController:Controller<{},ProductListViewModel> = () => {

    const [response, {subscribe}] = useAsyncAction(() => GlobalProductService.getGlobalProductList());
    // Input details
    useEffect(() => {
        if(!subscribe) {
            return
        }

        subscribe();
    }, [subscribe]);

    return {
        asyncResponse : response as AsyncActionState<AxiosResponse<IProduct[]> | null>
        ,
    };
};
